import { action } from '@ember/object';

import type { PopupData } from 'webapp-types';

import eq from 'webapp/helpers/eq';
import CommonPopupsMultiListListComponent from 'webapp/components/common/popups/multi-list/list';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';

export default class PopupMultiListComponent extends PopupInnerContextComponent<PopupData.Common.MultiList> {
	get itemLists() {
		return this.popupData.itemLists;
	}

	@action
	doAction(actionName?: string, ...args: unknown[]): void {
		if (!actionName) {
			return;
		}
		this.popupData.doAction(actionName, ...args);
		if (!this.popupData.skipCloseOnAction) {
			this.close();
		}
	}
	<template>
		{{#each this.itemLists as |list index|}}
			<CommonPopupsMultiListListComponent
				@items={{list}}
				@doAction={{this.doAction}}
				@skipLine={{eq index 0}}
			/>
		{{/each}}
	</template>
}
